function initMarketsDataTable() {
  const table = $("#markets-datatable");

  // Not a markets page.
  if (!table.length) {
    return;
  }

  const pageKey = `${window.location.pathname}${window.location.search}`;
  if (window.__xtrackerMarketsDataTableInitKey === pageKey) {
    return;
  }
  window.__xtrackerMarketsDataTableInitKey = pageKey;

  // Check if the table exists and jQuery/DataTables are available
  if (typeof jQuery !== 'undefined' && jQuery.fn.dataTable) {
    // Destroy existing DataTable if it exists
    if ($.fn.DataTable.isDataTable('#markets-datatable')) {
      $('#markets-datatable').DataTable().destroy();
    }
    
    try {
      table.dataTable({
        responsive: true,
        scrollCollapse: true,
        sDom: '<"row view-filter txt"<"col-sm-12 txt"<"pull-left txt"l><"pull-right txt"f><"clearfix txt">>>t<"row view-pager txt"<"col-sm-12 p-2 txt"<"text-center txt"p>>>',
        processing: true,
        serverSide: true,
        pageLength: 10,
        language: {
          stripClasses: "",
          search: '<span class="txt text-sm mr-2 mt-2">Search</span>',
          searchPlaceholder: "Enter Keywords Here...",
          lengthMenu:
            '<span class="float-right txt text-sm mt-1">Rows per page</span><select class="float-right mr-2 input input-sm rounded-sm">' +
            '<option value="10">10</option>' +
            '<option value="20">20</option>' +
            '<option value="30">30</option>' +
            '<option value="40">40</option>' +
            '<option value="50">50</option>' +
            '<option value="100">100</option>' +
            "</select>",
        },
        ajax: {
          url: table.data("source"),
        },
        pagingType: "simple_numbers",
        columns: [
          { data: "city" },
          { data: "state" },
          { data: "time_zone" },
          { data: "stations", orderable: false },
          { data: "users", orderable: false },
          { data: "actions", orderable: false }
        ],
        initComplete: function() {
          // Hide fallback content once DataTable is initialized
          const fallbackBody = document.getElementById('markets-tbody');
          if (fallbackBody) {
            fallbackBody.style.display = 'none';
          }
        },
        error: function(xhr, error, code) {
          console.log('DataTable error:', error, code);
          // Show fallback content on error
          const fallbackBody = document.getElementById('markets-tbody');
          if (fallbackBody) {
            fallbackBody.style.display = '';
          }
        }
      });
    } catch (error) {
      console.log('DataTable initialization failed:', error);
      // Ensure fallback content is visible on error
      const fallbackBody = document.getElementById('markets-tbody');
      if (fallbackBody) {
        fallbackBody.style.display = '';
      }
    }
  } else {
    console.log('Markets DataTable dependencies unavailable');
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initMarketsDataTable);

// Also listen for turbo events in case Turbo gets enabled later
document.addEventListener('turbo:load', initMarketsDataTable);

// Clean up before page cache
document.addEventListener("turbo:before-cache", function() {
  if (typeof jQuery !== 'undefined' && jQuery.fn.DataTable && $.fn.DataTable.isDataTable('#markets-datatable')) {
    $("#markets-datatable").DataTable().destroy();
  }
  window.__xtrackerMarketsDataTableInitKey = null;
});
